import { IssueLogger } from "../../Root/deferred/issueLogger";
import { IProductPage } from "../Interfaces/IProductPage";
import { StockLevel } from "../StockLevel";
import { IColourSizeSelector } from "./IColourSizeSelector";

export class ClickableSelector implements IColourSizeSelector {
    private stockLegendContainer: HTMLElement;
    private currentColourId: number = NaN;
    private currentSizeCode: string = "";

    constructor(private colours: { [key: string]: string }, private sizes: { [key: string]: string }, private productPage: IProductPage) {
        this.wireUpHandlers();
        this.initialiseUi();
    }

    private wireUpHandlers(): void {
        this.WireUpColourChanged();
        this.WireUpSizeChanged();
        this.WireUpSizeGroupSelected();
    }

    private initialiseUi(): void {
        // Find the colour radio button that is checked, if any.
        let checkedColourRadio = document.querySelector("input[name='colour']:checked") as HTMLInputElement;

        if (checkedColourRadio?.value) {
            this.currentColourId = parseInt(checkedColourRadio.value);
        }

        // Find the size radio button that is checked, if any.
        let checkedSizeRadio = document.querySelector("input[name='size']:checked") as HTMLInputElement;
        if (checkedSizeRadio?.value) {
            this.currentSizeCode = checkedSizeRadio.value;
        }

        this.stockLegendContainer = document.getElementById('stock-legend-container');
    }

    private WireUpSizeChanged() {
        let sizeRadios = document.getElementsByName("size");

        for (const sizeRadio of sizeRadios) {
            sizeRadio.addEventListener("change", (e) => this.onSizeChanged(e));
        }
    }

    private WireUpSizeGroupSelected() {
        let sizeGroupRadios = document.getElementsByName("size-group");

        for (const sizeGroupRadio of sizeGroupRadios) {
            sizeGroupRadio.addEventListener("change", (e) => this.onSizeGroupChanged(e));
        }
    }

    private WireUpColourChanged() {
        let colourRadios = document.getElementsByName("colour");

        for (const colourRadio of colourRadios) {
            colourRadio.addEventListener("change", (e) => this.onColourChanged(e));
        }
    }

    public SelectedSizeAndColour(): ISelectedSizeAndColour {
        return {
            colourId: this.currentColourId,
            size: this.currentSizeCode
        };
    }

    private onSizeChanged(e: Event): void {
        let clickedSize = <HTMLInputElement>e.currentTarget;

        let posCode = clickedSize.value;

        if (!posCode) {
            IssueLogger.log("posCode was null", "onSizeChanged", clickedSize);
            return;
        }

        this.currentSizeCode = posCode;
        this.updateColourStockStatus(this.currentSizeCode);
        this.productPage.ProductSelectionChanged(this.SelectedSizeAndColour());
    }

    private updateColourStockStatus(selectedSize: string): void {
        for (let colourId in this.colours) {
            let itemInfo = this.productPage.StockInfoForSizeAndColour(parseInt(colourId), selectedSize);

            if (!itemInfo) {
                continue;
            }

            let stockText = this.cssClassAndTextForStockStatus(itemInfo.availability);
            let colourRadio = document.querySelector("input[name='colour'][value='" + colourId + "']") as HTMLInputElement;
            let colourLi = colourRadio?.closest("li");

            if (colourLi) {
                colourLi.classList.remove("instock", "discontinued", "requestemail");
                colourLi.classList.add(stockText.cssClass);
                colourLi.attributes["alt"] = stockText.text;
            }
        }
        this.updateLegendVisibility();
    }

    /**
     * Shows or hides the 'out of stock' legend depending on if there are out of stock sizes in the UI.
     */
    private updateLegendVisibility(): void {
        let outOfStockSizes = document.querySelectorAll('#size-list > li.requestemail');
        if (outOfStockSizes.length > 0) {
            this.stockLegendContainer.classList.remove('hidden');
        }
        else {
            this.stockLegendContainer.classList.add('hidden');
        }
    }

    private cssClassAndTextForStockStatus(status: StockLevel): ISelectedStockStatus {

        if (StockLevel.Stock_InStock === status || StockLevel.Stock_LowStock === status) {
            return <ISelectedStockStatus>{
                cssClass: 'instock',
                text: 'Order Now'
            };
        }
        else if (StockLevel.Stock_Unavailable === status) {
            return <ISelectedStockStatus>{
                cssClass: 'discontinued',
                text: 'Discontinued and Sold Out'
            };
        }
        return <ISelectedStockStatus>{
            cssClass: 'requestemail',
            text: 'Out of Stock (Request Email Alert)'
        };

    }

    private onSizeGroupChanged(e: Event): void {
        let csg = e.currentTarget as HTMLElement;
        let currentSizeGroup = csg.closest("li").dataset.sizeGroupId;

        //csg.classList.add('active');

        // Change all sizes to the text for the group selected.
        let sizeRadios = document.getElementsByName("size");

        for (const sizeRadio of sizeRadios) {
            let sizeSpanElement = sizeRadio.nextElementSibling as HTMLElement;

            if (currentSizeGroup === 'EU') {
                sizeSpanElement.textContent = sizeRadio.dataset.eu;
            }
            else if (currentSizeGroup === 'US') {
                sizeSpanElement.textContent = sizeRadio.dataset.us;
            }
            else {
                sizeSpanElement.textContent = sizeRadio.dataset.uk;
            }
        }
    }

    private onColourChanged(e: Event): void {
        let clickedElement = <HTMLInputElement>e.currentTarget;

        this.currentColourId = parseInt(clickedElement.value);
        this.productPage.FindAndClickThumbnail(this.currentColourId);
        this.LoadSizes();
    }

    private LoadSizes(): void {

        for (let sizeCode in this.sizes) {
            let itemInfo = this.productPage.StockInfoForSizeAndColour(this.currentColourId, sizeCode);

            if (!itemInfo) {
                continue;
            }

            let stockText = this.cssClassAndTextForStockStatus(itemInfo.availability);

            let sizeRadio = document.querySelector("input[name='size'][value='" + sizeCode + "']") as HTMLInputElement;

            if (sizeRadio) {
                let sizeLi = sizeRadio.closest("li");

                sizeLi.classList.remove("instock", "discontinued", "requestemail");
                sizeLi.classList.add(stockText.cssClass);
                sizeLi.attributes["alt"] = stockText.text;
            }
        }

        this.updateLegendVisibility();

        // Tell the product page that it should clear linked products etc as no product is selected.
        this.productPage.ProductSelectionChanged(this.SelectedSizeAndColour());
    }
}
